import {mean, sum, values} from 'lodash';

const TEST_NAMES = {
  actPlan: 'ACT Plan',
  preAct: 'Pre-ACT',
  psat: 'PSAT',
  psat2015: 'PSAT',
  act: 'Legacy ACT',
  act2025: 'ACT',
  sat: 'SAT',
  sat2016: 'SAT',
  ap: (testScore) => `AP ${testScore.subject}`,
  other: (testScore) => testScore.name,
};

const TEST_SCORES = {
  act: 'mean',
  act2025: 'mean',
  preAct: 'mean',
};

const TEST_SCORE_CALCULATORS = {
  mean: (scores) => mean(scores),
  sum: (scores) => sum(scores),
};

export const testScoreName = (testScore) => {
  const name = TEST_NAMES[testScore.type];
  return typeof name === 'function' ? name(testScore) : name;
};

export const testScoreText = (testScore) => {
  const max = testScore.maxScore;
  const scores = values(testScore.scores);
  const scoreCalculatorType = TEST_SCORES[testScore.type] || 'sum';
  const score = TEST_SCORE_CALCULATORS[scoreCalculatorType](scores);

  let text = '';

  if (max) {
    if (scores.length > 1) {
      text += 'Overall ';
    }

    text += 'Score - ';
  }

  text += ` ${score}`;

  if (max) {
    text += ` / ${max}`;
  }

  return text;
};

export const TEST_SECTION_NAMES = {
  actScoreEnglish: 'English',
  actScoreMath: 'Math',
  actScoreReading: 'Reading',
  actScoreScience: 'Science',
  act2025ScoreEnglish: 'English',
  act2025ScoreMath: 'Math',
  act2025ScoreReading: 'Reading',
  act2025ScoreScience: 'Science',
  scoreMathematics: 'Math',
  scoreReadingAndWriting: 'Writing & Language',
  sat2016ScoreMathematics: 'Math',
  sat2016ScoreReadingAndWriting: 'Reading & Writing',
  satScoreCriticalReading: 'Critical Reading',
  satScoreMathematics: 'Math',
  satScoreWriting: 'Writing & Language',
  satScoreEssay: 'Essay',
  satScoreMultipleChoice: 'Multiple Choice',
  psat2015ScoreWritingLanguage: 'Writing & Language',
  psat2015ScoreMathematics: 'Math',
  preActScoreEnglish: 'English',
  preActScoreMathematics: 'Math',
  preActScoreReading: 'Reading',
  preActScoreScience: 'Science',
  psatScoreCriticalReading: 'Critical Reading',
  psatScoreMathematics: 'Math',
  psatScoreWriting: 'Writing',
  actPlanScoreEnglish: 'English',
  actPlanScoreMathematics: 'Math',
  actPlanScoreReading: 'Reading',
  actPlanScoreScience: 'Science',
};
